"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _QrCodeDialogController = require("./QrCodeDialogController");
Object.keys(_QrCodeDialogController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QrCodeDialogController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _QrCodeDialogController[key];
    }
  });
});
